import {
  TransactionFromTypes,
  TransactionToTypes,
} from 'app/modules/goAML/models';
import { OFFSET_DEFAULT, PAGE_LIMIT_DEFAULT } from 'app/shared/constants';
import { GetSARsPayload } from 'app/modules/fincenSAR/requests';

export const GOAML_TXN_FROM_TO_TYPE_TEXT = {
  [TransactionFromTypes.EMPTY_FROM]: '(not selected)',

  [TransactionFromTypes.FROM_ACCOUNT]: 'Account',
  [TransactionFromTypes.FROM_ACCOUNT_MY_CLIENT]: 'Account (My Client)',

  [TransactionFromTypes.FROM_PERSON]: 'Person',
  [TransactionFromTypes.FROM_PERSON_MY_CLIENT]: 'Person (My Client)',

  [TransactionFromTypes.FROM_ENTITY]: 'Entity',
  [TransactionFromTypes.FROM_ENTITY_MY_CLIENT]: 'Entity (My Client)',

  [TransactionToTypes.EMPTY_TO]: '(not selected)',

  [TransactionToTypes.TO_ACCOUNT]: 'Account',
  [TransactionToTypes.TO_ACCOUNT_MY_CLIENT]: 'Account (My Client)',

  [TransactionToTypes.TO_PERSON]: 'Person',
  [TransactionToTypes.TO_PERSON_MY_CLIENT]: 'Person (My Client)',

  [TransactionToTypes.TO_ENTITY]: 'Entity',
  [TransactionToTypes.TO_ENTITY_MY_CLIENT]: 'Entity (My Client)',
};

export const ACCEPTABLE_FILE_EXTENSIONS = [
  '.doc',
  '.docx',
  '.xml',
  '.png',
  '.jpg',
  '.pdf',
  '.xls',
  '.xlsx',
  '.rtf',
  '.txt',
];
export const DOCUMENT_UPLOAD_LIMIT = 50 * 1024 * 1024; // 50 MB

export const INITIAL_FILTERS: GetSARsPayload = {
  statuses: [],
  limit: PAGE_LIMIT_DEFAULT,
  offset: OFFSET_DEFAULT,
};

// Path without indexes
export const EMPTY_TRANSACTIONS_PATH = 'content.report.transaction';
